import React from 'react';
import { Quote } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { testimonials } from '../content/testimonials';

const TITLE = { it: 'Cosa dicono i nostri rivenditori', en: 'What our resellers say' };

export const Testimonials = () => {
  const { language } = useLanguage();
  if (!testimonials.length) return null;

  return (
    <section className="section-spacing bg-[#F9F9F9]" data-testid="testimonials-section">
      <div className="container-luxury">
        <h2 className="font-heading text-3xl sm:text-4xl mb-12">{TITLE[language]}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((r, i) => (
            <figure key={r.name + i} className="bg-white p-8" data-testid={`testimonial-${i}`}>
              <Quote size={24} className="text-gold mb-4" />
              <blockquote className="text-gray-700 leading-relaxed mb-6">{r.text}</blockquote>
              <figcaption className="text-sm">
                <span className="font-medium block">{r.name}</span>
                <span className="text-gray-500">{r.business} · {r.city}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
